<div class="card mt-4">
  <div class="card-header fw-bold">
    {{ "Sellers.Dashboard.SendMarketingSMSs" | translate }}
  </div>
  <div class="card-body" *ngIf="smsForm">
    <form [formGroup]="smsForm" *ngIf="smsForm" novalidate>
      <div class="row ng-star-inserted">
        <div class="col-md-12">
          <label class="form-label mb-0"
            >{{ "Sellers.Dashboard.Body" | translate }}
            <span class="text-danger">*</span></label
          >
          <div class="form-icon position-relative">
            <i data-feather="user" class="fea icon-sm icons"></i>
            <input
              type="text"
              class="form-control px-2"
              placeholder="{{ 'Sellers.Dashboard.Body' | translate }}"
              formControlName="Body"
              [ngClass]="formValidator.formErrors.Body ? 'border-danger' : ''"
            />
            <label class="text-secondary">{{ businessSignature }}</label>
            <div
              class="text-danger fs-7"
              *ngIf="formValidator?.formErrors?.Body"
            >
              {{ formValidator.formErrors.Body }}
            </div>
            <div>
              <button class="btn btn-sm bg-white text-dark" disabled>
                {{
                  "Sellers.Dashboard.MessageLength"
                    | translate: { messageLength: messageLength }
                }}
              </button>
            </div>
            <div>
              <button class="btn btn-sm bg-white text-dark" disabled>
                {{
                  "Sellers.Dashboard.MessageDivision"
                    | translate: { messagesNumber: messagesNumber }
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <button
      [disabled]="isSubmitting || !smsForm.valid"
      class="btn btn-primary m-2 pull-right"
      type="button"
      (click)="submit()"
    >
      {{ "Sellers.Products.Submit" | translate }}
    </button>
  </div>
</div>
